import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';

@Injectable()
export class AppNavigationService {
    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService
    ) { }

    getMenu(): AppMenu {
        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-list-3', '/app/admin/tenants'),
            new AppMenuItem('Editions', 'Pages.Editions', 'flaticon-app', '/app/admin/editions'),
            new AppMenuItem(
                'Offer Management',
                'Pages.OfferManagement',
                'flaticon-interface',
                '/app/main/offers',
                ['nav-offer-management']
            ),
            new AppMenuItem(
                'Licensee Management',
                'Pages.LicenseeManagement',
                'flaticon-network',
                '/app/main/licensee-management',
                ['nav-licensee-management']
            ),
            new AppMenuItem(
                'Reporting',
                'Pages.Reporting',
                'flaticon-graph',
                '',
                ['nav-reporting']
                , [

                    new AppMenuItem(
                        'Reporting.Users',
                        'Pages.Reporting.Users',
                        'fa fa-user-o',
                        '/app/reporting/user-reports',
                        ['nav-report-users']
                    ),
                    new AppMenuItem(
                        'Reporting.AdditionalReports',
                        'Pages.Reporting.AdditionalReports',
                        'fa fa-file-excel-o',
                        '/app/reporting/additional-reports',
                        ['nav-report-additional-reports']
                    )]
            ),

            new AppMenuItem(
                'DataManagement',
                'Pages.DataManagement',
                'flaticon-tool',
                '',
                ['nav-data-management']
                ,[
                    new AppMenuItem(
                        'DataManagement.Products',
                        'Pages.DataManagement.Products',
                        'flaticon-open-box',
                        '/app/data-management/products',
                        ['nav-dm-products']
                    ),
                    new AppMenuItem(
                        'DataManagement.Organizations',
                        'Pages.DataManagement.Organizations',
                        'pi pi-building',
                        '/app/data-management/organizations',
                        ['nav-dm-organizations']
                    ),
                    new AppMenuItem(
                        'DataManagement.Enrollment',
                        'Pages.DataManagement.Enrollment',
                        'pi pi-user-plus',
                        '/app/data-management/enrollment',
                        ['nav-dm-enrollment']
                    ),
                    new AppMenuItem(
                        'MassEnrollment',
                        'Pages.DataManagement.MassEnrollmentUpload',
                        'pi pi-users',
                        '/app/data-management/mass-enrollment',
                        ['nav-mass-enrollment']
                    ),
                    new AppMenuItem(
                        'EnrollmentException',
                        'Pages.DataManagement.EnrollmentExceptionUpload',
                        'flaticon-interface',
                        '/app/data-management/enrollment-exception',
                        ['nav-enrollment-exception']
                    ),
                    new AppMenuItem(
                        'CustomEarnings',
                        'Pages.DataManagement.CustomEarningsUpload',
                        'flaticon-piggy-bank',
                        '/app/data-management/custom-earnings',
                        ['nav-custom-earnings']
                    )]
            ),
            new AppMenuItem(
                'Administration',
                '',
                'flaticon-interface-8',
                '',
                ['nav-administration'], [
                new AppMenuItem(
                    'SeasonRollover',
                    'Pages.Administration.SeasonRollover',
                    'flaticon-calendar-1',
                    '/app/admin/season-rollover',
                    ['nav-season-rollover']
                ),
                new AppMenuItem(
                    'Hierarchies',
                    'Pages.Administration.OrganizationUnits',
                    'flaticon-map',
                    '/app/admin/hierarchy-management',
                    ['nav-hierarchies']
                ),
                new AppMenuItem(
                    'Roles',
                    'Pages.Administration.Roles',
                    'flaticon-suitcase',
                    '/app/admin/roles',
                    ['nav-roles']
                ),
                new AppMenuItem(
                    'Users',
                    'Pages.Administration.Users',
                    'flaticon-users',
                    '/app/admin/users',
                    ['nav-users']
                ),
                new AppMenuItem(
                    'Languages',
                    'Pages.Administration.Languages',
                    'flaticon-tabs',
                    '/app/admin/languages',
                    ['nav-languages']
                ),
                new AppMenuItem(
                    'AuditLogs',
                    'Pages.Administration.AuditLogs',
                    'flaticon-folder-1',
                    '/app/admin/auditLogs',
                    ['nav-audit-logs']
                ),
                new AppMenuItem(
                    'Maintenance',
                    'Pages.Administration.Host.Maintenance',
                    'flaticon-lock',
                    '/app/admin/maintenance',
                    ['nav-maintenance']
                ),
                new AppMenuItem(
                    'Subscription',
                    'Pages.Administration.Tenant.SubscriptionManagement',
                    'flaticon-refresh',
                    '/app/admin/subscription-management',
                    ['nav-subscription']
                ),
                new AppMenuItem(
                    'VisualSettings',
                    'Pages.Administration.UiCustomization',
                    'flaticon-medical',
                    '/app/admin/ui-customization',
                    ['nav-visual-settings']),
                new AppMenuItem(
                    'Settings',
                    'Pages.Administration.Host.Settings',
                    'flaticon-settings',
                    '/app/admin/hostSettings',
                    ['nav-host-settings']),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Tenant.Settings',
                        'flaticon-settings',
                        '/app/admin/tenantSettings',
                        ['nav-tenant-settings']
                    ),
            ]),
            new AppMenuItem(
                'DemoUiComponents',
                'Pages.DemoUiComponents',
                'flaticon-shapes',
                '/app/admin/demo-ui-components'
            ),
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === '' || subMenuItem.permissionName === null) {
                if (subMenuItem.route) {
                    return true;
                }
            } else if (this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                if (!subMenuItem.hasFeatureDependency()) {
                    return true;
                }

                if (subMenuItem.featureDependencySatisfied()) {
                    return true;
                }
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }

        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (
            menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' &&
            this._appSessionService.tenant &&
            !this._appSessionService.tenant.edition
        ) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach((menuItem) => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach((subMenu) => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }
}
